import { faList, faTableCells } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useEffect, useState } from 'react';
import SortBy from 'components/shared/SortBy';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { getsortOptions } from 'constants/package';
import { PackageFilterModel } from 'ts/package/classes/PackageFilterModel';
import { useTranslation } from 'react-i18next';
import { formatPriceCurrency } from 'utils/utils';
import Button from 'components/ui/Button/Button';
import Skeleton from 'react-loading-skeleton';

interface ResultTopBarProps {
  onSortChange: (sort: string) => void;
  filter?: PackageFilterModel;
  onChangeFilter: (filter: PackageFilterModel) => void;
  sessionKey: string;
  newSort: string;
}

const ResultTopBar: FC<ResultTopBarProps> = (props) => {
  const [t] = useTranslation();
  const [mode, setMode] = useState<'list' | 'card'>('list');

  useEffect(() => {
    const view = localStorage.getItem('packageView');
    if (view === 'card') {
      onClickCardView();
    }
  }, [props.filter]);

  const onClickListView = () => {
    const view = document.querySelector('.package-list');
    view?.classList.remove('package-list-card');
    setMode('list');
    localStorage.removeItem('packageView');
  };

  const onClickCardView = () => {
    const view = document.querySelector('.package-list');
    view?.classList.add('package-list-card');
    setMode('card');
    localStorage.setItem('packageView', 'card');
  };

  const onClickNight = (index: number) => {
    const newNights = props.filter!.nights.map((item) => ({ ...item, checked: false }));
    newNights[index].checked = true;
    props.onChangeFilter({ ...props.filter!, nights: newNights });
  };

  return (
    <Fragment>
      <div className="results-sort-by results-sort-by-package">
        <SortBy
          options={getsortOptions()}
          onSortChange={props.onSortChange}
          newSort={props.newSort}
        />
        <div className="show-laptop-sm package-top-mobile">
          {props.filter ? (
            <Fragment>
              <Button
                title={t('filter.s')}
                className="btn btn-default"
                onClick={() => {
                  const element = document.querySelector('.flight-filter-wr') as HTMLElement;
                  element.classList.toggle('visible-responsive');
                }}
              />
              <Button
                title={t('sort.er')}
                className="btn btn-default"
                onClick={() => {
                  const element = document.querySelector('.sort-responsive') as HTMLElement;
                  element.classList.toggle('visible-responsive');
                }}
              />
            </Fragment>
          ) : (
            <Fragment>
              <Skeleton width="calc(50vw - 15px)" height={38} />
              <Skeleton width="calc(50vw - 15px)" height={38} />
            </Fragment>
          )}
        </div>
        <div className="ml-a">
          {props.filter ? (
            <div className="results-display-list hide-laptop-sm">
              <FontAwesomeIcon
                className={'icon' + (mode === 'list' ? ' active' : '')}
                icon={faList}
                onClick={onClickListView}
              />
              <FontAwesomeIcon
                className={'icon' + (mode === 'card' ? ' active' : '')}
                icon={faTableCells}
                onClick={onClickCardView}
              />
            </div>
          ) : (
            <Skeleton width={74} height={32} className="hide-laptop-sm" style={{ marginTop: 4 }} />
          )}
        </div>
      </div>

      <div className="package-top-filter hide-laptop-sm">
        <div className="package-top-filter-wr">
          {!!props.filter ? (
            props.filter.nights.map((night, index) => (
              <div
                key={night + ''}
                className={'text-xsm item' + (night.checked ? ' active' : '')}
                onClick={() => onClickNight(index)}
              >
                <div className="item-wr">
                  <div>{`${night.count} ${t('package.nts')} (${night.packagesCount})`}</div>
                  <div>
                    <span className="text-bold text-sm">
                      {formatPriceCurrency(night.minPrice, props.filter?.currencySign || '')}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <span className="flex-row">
              {[...Array(3)].map((_, index) => (
                <Skeleton width={200} height={38} key={index} className="mr-10" />
              ))}
            </span>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default withErrorBoundary(ResultTopBar, 'ResultTopBar');
